import React from 'react';
import { isMobileDevice } from '../utils/deviceDetection';
import sigmaLogo from '../Images/sigma-bank-logo.png';

const DesktopBlocker = ({ children }) => {
    if (isMobileDevice()) {
        return children;
    }

    return (
        <div style={styles.wrapper}>
            <div style={styles.bgOrb1}></div>
            <div style={styles.bgOrb2}></div>
            <div style={styles.bgOrb3}></div>

            <div style={styles.container}>
                <div style={styles.card}>
                    {/* Logo */}
                    <div style={styles.logoCircle}>
                        <img src={sigmaLogo} alt="Sigma Bank" style={styles.logoImage} />
                    </div>

                    {/* Brand */}
                    <div style={styles.brandRow}>
                        <div style={styles.brandDot}></div>
                        <span style={styles.brandName}>Sigma Bank</span>
                    </div>

                    {/* Message */}
                    <h1 style={styles.title}>Mobile Access Only</h1>
                    <p style={styles.message}>
                        Please use your phone to access your Sigma Bank account.
                    </p>

                    {/* Divider */}
                    <div style={styles.divider}></div>

                    {/* Steps */}
                    <div style={styles.steps}>
                        <div style={styles.step}>
                            <div style={styles.stepIcon}>
                                <i className='bx bx-user-plus' style={styles.stepIconI}></i>
                            </div>
                            <div>
                                <p style={styles.stepTitle}>Register</p>
                                <p style={styles.stepDesc}>Don't have an account? Register first on your mobile device</p>
                            </div>
                        </div>
                        <div style={styles.step}>
                            <div style={styles.stepIcon}>
                                <i className='bx bx-log-in' style={styles.stepIconI}></i>
                            </div>
                            <div>
                                <p style={styles.stepTitle}>Sign In</p>
                                <p style={styles.stepDesc}>Use your credentials to log in securely</p>
                            </div>
                        </div>
                        <div style={styles.step}>
                            <div style={styles.stepIcon}>
                                <i className='bx bx-check-shield' style={styles.stepIconI}></i>
                            </div>
                            <div>
                                <p style={styles.stepTitle}>You're All Set</p>
                                <p style={styles.stepDesc}>Full access to your dashboard and wallet</p>
                            </div>
                        </div>
                    </div>

                    {/* Footer note */}
                    <p style={styles.footerNote}>
                        <i className='bx bx-lock-alt' style={{ marginRight: '6px', fontSize: '14px' }}></i>
                        Secured with end-to-end encryption
                    </p>
                </div>

                <p style={styles.copyright}>&copy; {new Date().getFullYear()} Sigma Bank. All rights reserved.</p>
            </div>
        </div>
    );
};

const styles = {
    wrapper: {
        minHeight: '100vh',
        width: '100%',
        background: 'linear-gradient(160deg, #060320 0%, #0e0758 30%, #1a0d4d 60%, #0a0630 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    },
    bgOrb1: {
        position: 'absolute',
        top: '-15%',
        right: '-10%',
        width: '500px',
        height: '500px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(25,191,177,0.12) 0%, transparent 70%)',
        pointerEvents: 'none',
    },
    bgOrb2: {
        position: 'absolute',
        bottom: '-10%',
        left: '-8%',
        width: '400px',
        height: '400px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(14,7,88,0.3) 0%, transparent 70%)',
        pointerEvents: 'none',
    },
    bgOrb3: {
        position: 'absolute',
        top: '40%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '600px',
        height: '600px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(25,191,177,0.05) 0%, transparent 60%)',
        pointerEvents: 'none',
    },
    container: {
        position: 'relative',
        zIndex: 1,
        textAlign: 'center',
        padding: '40px 20px',
        width: '100%',
        maxWidth: '480px',
    },
    card: {
        background: 'rgba(255, 255, 255, 0.04)',
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: '24px',
        padding: '48px 40px 40px',
        boxShadow: '0 24px 80px rgba(0, 0, 0, 0.3)',
    },
    logoCircle: {
        width: '90px',
        height: '90px',
        borderRadius: '50%',
        background: '#FFFFFF',
        border: '2px solid rgba(25, 191, 177, 0.35)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 24px',
        boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
    },
    logoImage: {
        width: '55px',
        height: 'auto',
    },
    brandRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        marginBottom: '20px',
    },
    brandDot: {
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        background: '#19bfb1',
    },
    brandName: {
        fontSize: '13px',
        fontWeight: '600',
        color: 'rgba(255, 255, 255, 0.5)',
        textTransform: 'uppercase',
        letterSpacing: '2px',
    },
    title: {
        fontSize: '26px',
        fontWeight: '700',
        color: '#ffffff',
        margin: '0 0 12px',
        letterSpacing: '-0.3px',
    },
    message: {
        fontSize: '15px',
        color: 'rgba(255, 255, 255, 0.6)',
        lineHeight: '1.6',
        margin: '0 0 28px',
    },
    divider: {
        width: '40px',
        height: '2px',
        background: 'linear-gradient(90deg, transparent, rgba(25,191,177,0.4), transparent)',
        margin: '0 auto 28px',
    },
    steps: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginBottom: '28px',
        textAlign: 'left',
    },
    step: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        background: 'rgba(255, 255, 255, 0.03)',
        borderRadius: '12px',
        padding: '14px 16px',
        border: '1px solid rgba(255, 255, 255, 0.05)',
    },
    stepIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '10px',
        background: 'rgba(25, 191, 177, 0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    stepIconI: {
        fontSize: '17px',
        color: '#19bfb1',
    },
    stepTitle: {
        fontSize: '13px',
        fontWeight: '600',
        color: '#ffffff',
        margin: '0 0 2px',
    },
    stepDesc: {
        fontSize: '12px',
        color: 'rgba(255, 255, 255, 0.45)',
        margin: 0,
        lineHeight: '1.4',
    },
    footerNote: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        color: 'rgba(255, 255, 255, 0.35)',
        margin: 0,
    },
    copyright: {
        fontSize: '11px',
        color: 'rgba(255, 255, 255, 0.25)',
        marginTop: '24px',
    },
};

export default DesktopBlocker;
